<template>
	<el-dialog
		:model-value="!!currentMessage"
		width="420px"
		class="sys-message-dialog"
		align-center
		destroy-on-close
		:close-on-click-modal="false"
		:show-close="true"
		@close="handleClose"
	>
		<template #header>
			<div class="sys-message-header">
				<span class="sys-message-title">{{ currentMessage?.title || '系统消息' }}</span>
			</div>
		</template>

		<div v-if="currentMessage" class="sys-message-body">
			<img v-if="currentMessage.image" :src="currentMessage.image" alt="" class="sys-message-image" />
			<p class="sys-message-content">{{ currentMessage.content }}</p>
		</div>

		<template #footer>
			<div class="sys-message-footer">
				<el-button @click="handleClose">知道了</el-button>
				<el-button v-if="showActionButton" type="primary" @click="handleAction">
					{{ currentMessage?.buttonText }}
				</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useSysMessageStore } from '@/stores/sysMessage'
import { canSysMessageJump } from '@/utils/mqtt/jump'

const sysMessageStore = useSysMessageStore()
const { currentMessage } = storeToRefs(sysMessageStore)

const showActionButton = computed(() => {
	if (!currentMessage.value?.buttonText) return false
	return canSysMessageJump(currentMessage.value.attachment)
})

const handleClose = () => {
	sysMessageStore.closeCurrent()
}

const handleAction = () => {
	sysMessageStore.handleAction()
}
</script>

<style scoped>
.sys-message-header {
	display: flex;
	align-items: center;
	justify-content: center;
}

.sys-message-title {
	font-size: 18px;
	font-weight: 600;
	color: #111827;
}

.sys-message-body {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.sys-message-image {
	width: 100%;
	border-radius: 8px;
	object-fit: cover;
}

.sys-message-content {
	margin: 0;
	font-size: 14px;
	line-height: 1.7;
	color: #4b5563;
	white-space: pre-wrap;
	word-break: break-word;
}

.sys-message-footer {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}

:deep(.sys-message-dialog .el-dialog) {
	border-radius: 16px;
}

:deep(.sys-message-dialog .el-dialog__header) {
	padding-bottom: 8px;
	margin-right: 0;
}

:deep(.sys-message-dialog .el-dialog__body) {
	padding-top: 8px;
}
</style>
